<template>
<CRow class="mt-3">
    <CCol col="12" sm="12" md="10" lg="7" xl="6" class="mx-auto">
        <ValidationObserver tag="div" class="p-3 b-a-2 bg-white" ref="form" v-slot="{ handleSubmit, invalid }">
            <Loading />
            <Message />
            <div class="alert alert-warning">{{ $t('v2commission.default_model.alert') }}</div>

            <CForm method="post" @submit.prevent="handleSubmit(submit)">
                <CCard class="bg-primary text-white">
                    <CCardBody class="py-3 px-1">
                        <CRow class="p-0 align-items-center">
                            <CCol col="12" md="4" lg="3" class="text-center b-l-2">
                                <h2>{{ $t('v2commission.default_model.sale._') }}</h2>
                            </CCol>
                            <CCol col="12" md="8" lg="9" class="m-auto">
                                <span>{{ $t('v2commission.default_model.sale.description') }}</span>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardBody class="bg-white text-dark">
                        <CRow>
                            <CCustomSelect
                                col="12"
                                md="5"
                                lg="4"
                                v-model="defaultCommission.sale.action_type"
                                :name="$t('v2commission.type_of_commission_amount')"
                                :options="commissionAmountTypeOption"
                                vid="action_type"
                            />
                            <CCustomInput
                                col="12"
                                md="7"
                                lg="8"
                                vid="action_value"
                                :name="$t('v2commission.commission_amount')"
                                rules="required|double_or_numeric|min_value:0.1"
                                required
                                ltr
                                v-model="defaultCommission.sale.action_value"
                            >
                                <template
                                    #append-content
                                >{{ defaultCommission.sale.action_type === CommissionAmountType.PERCENT ? $t('percent') : $t('rial') }}</template>
                            </CCustomInput>
                        </CRow>
                    </CCardBody>
                </CCard>

                <CCard class="bg-primary text-white">
                    <CCardBody class="py-3 px-1">
                        <CRow class="p-0 align-items-center">
                            <CCol col="12" md="4" lg="3" class="text-center b-l-2">
                                <h2>{{ $t('v2commission.default_model.lead._') }}</h2>
                            </CCol>
                            <CCol col="12" md="8" lg="9" class="m-auto">
                                <span>{{ $t('v2commission.default_model.lead.description') }}</span>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardBody class="bg-white text-dark">
                        <CRow>
                            <CCustomInput
                                col="12"
                                class="mx-auto"
                                vid="action_value"
                                :name="$t('v2commission.commission_amount')"
                                rules="required|double_or_numeric"
                                required
                                ltr
                                v-model="defaultCommission.lead.action_value"
                            >
                                <template #append-content>{{ $t('rial') }}</template>
                            </CCustomInput>
                        </CRow>
                    </CCardBody>
                </CCard>

                <CRow>
                    <CCol col="12" class="b-t-1 pt-2 mt-3">
                        <CButton :disabled="invalid" type="submit" color="primary" class="px-4 float-right">{{ $t('btn.next_step') }}</CButton>
                        <CButton type="button" @click="prev" color="outline-primary" class="px-4">{{ $t('btn.prev_step') }}</CButton>
                    </CCol>
                </CRow>
            </CForm>
        </ValidationObserver>
    </CCol>
</CRow>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { commissionAmountTypeOption } from '@/common/data'
import { CommissionModel, CommissionAmountType, CommissionType } from '@/constants'
import { filterObject } from '@/common/objects'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'Default',

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fetchCommissions({
				no_paginate: true
			})
        })
    },

    data() {
        return {
            commission: {},
            commissionAmountTypeOption,
            CommissionAmountType,
        }
    },

    computed: {
        ...mapGetters({
            commissions: 'v2commission/commissions',
            store: 'store/firstStore'
        }),
        storeId() {
            return this.store.id
        },
        defaults() {
            return filterObject(
                this.commissions,
                commission => commission.model === CommissionModel.DEFAULT && commission.type === CommissionType.MIX
            )
        },
        defaultCommission() {
            const defaultIndex = Object.keys(this.defaults)[0]

            this.commission = defaultIndex ? this.defaults[defaultIndex] : {
                sale: {
                    action_type: CommissionAmountType.PERCENT,
                    action_value: '0'
                },
                lead: {
                    action_type: CommissionAmountType.AMOUNT,
                    action_value: '0'
                },
                model: CommissionModel.DEFAULT,
                store_id: this.storeId,
                type: CommissionType.MIX
            }

            return this.commission
        },
        checkSetCommission() {
            return Object.keys(this.commissions).length > 0
        },
    },

    methods: {
        ...mapActions({
            fetchStores: 'store/fetch',
            fetchCommissions: 'v2commission/fetch',
            create: 'v2commission/create',
            edit: 'v2commission/edit',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            changeCurrentUserSetupStatus: 'user/changeCurrentUserSetupStatus',
        }),
        submit() {
            this.setShowLoading()
            this.resetMsg()

            const form = this.defaultCommission.id ? this.edit(this.defaultCommission) : this.create(this.defaultCommission)
            form
                .then(res => {
                    this.changeCurrentUserSetupStatus(UserSetupStatus.ACCEPT_AGREEMENT).then(() => {
                        this.setShowLoading(false)
                    })
                }).catch(result => {
                    if (result.data) {
                        this.$refs.form.setErrors(result.data)
                    }
                    this.setMsg({
                        content: this.$t('tags.' + result.tag),
                        type: 'danger',
                    })
                })
        },
        prev() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.STORE_INFO).then(() => {
                this.setShowLoading(false)
            })
        }
    }
}
</script>